<template>
  <div class="am-finance-contract-agreement">
    <div class="am-header am-main-top-box">
      <span class="am-title am-main-top-box-title"><strong>Finance Contract Status</strong></span>
    </div>
    <p class="am-finance-contract-agreement-content" v-if="contractAgreement.isChecked">Finance Contract issued.<br/>
      Advise Customer: Contract has been sent to <strong>{{contractAgreement.customerEmail}}</strong> for eSignature.<br/><br/>
      Click "Ok" to process the Down Payment
    </p>
    <p class="am-finance-contract-agreement-content" v-if="!contractAgreement.isChecked">Finance Contract issued.<br/><br/>
      Click "Ok" to download the Contract and process the Down Payment
    </p>
    <div class="am-blue-border"></div>
    <div class="am-buttons">
      <a :href='returnPath' target="_blank" title="Download" class="am-download-process-button" v-if="!contractAgreement.isChecked" @click="closeModal()">Ok</a>
      <button type="button" class="btn btn-primary btn-xs" title="Close" v-if="contractAgreement.isChecked" @click="closeModal()">Ok</button>
    </div>
  </div>
</template>

<script>
    export default {
        name: "FinanceContractAgreement",
        props: {
            contractAgreement: Object,
        },
        methods: {
            closeModal() {
                this.$store.dispatch('events/fireEvent', { name: 'close-contract-agreement', data: {'isChecked': this.contractAgreement.isChecked }})
            }
        },
        computed: {
            returnPath() {
                return '/attc2/' + this.contractAgreement.path.substring(15)
            }
        }
    }
</script>

<style scoped>
  .am-finance-contract-agreement {
    width: 450px;
    background-color: whitesmoke;
    overflow: hidden;
  }

  .am-finance-contract-agreement-content {
    padding: 15px;
  }

  .am-header {
    height: 35px;
  }

  .am-title {
    font-size: 14px;
    font-weight: bold;
    float: left;
    padding: 8px 8px 8px 15px;
  }

  .am-buttons {
    bottom: 0;
    padding: 9px 7px 10px 0px;
    float: right;
  }

  .am-buttons button {
    margin: 0px 2px 0px 0px;
    padding: 0px 12px 0px 12px;
  }

  .am-blue-border {
    display: block;
    width: 100%;
    border-top: 1px solid #4297d7;
    margin-top: 10px;
  }

  .am-download-process-button {
    background-image: none;
    background-color: #428BCA;
    color: #FFFFFF;
    padding: 2px 12px 2px 12px;
    line-height: 1.5;
    text-decoration: none;
  }

  .am-download-process-button:hover {
    background-image: none;
    background-color: #2D6CA2;
    color: #FFFFFF;
  }

</style>
